var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAddCircleOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 14C9.44775 14 9 13.5522 9 13L9 11L7 11C6.44775 11 6 10.5522 6 10C6 9.44775 6.44775 9 7 9L9 9L9 7C9 6.44775 9.44775 6 10 6C10.5522 6 11 6.44775 11 7L11 9L13 9C13.5522 9 14 9.44775 14 10C14 10.5522 13.5522 11 13 11L11 11L11 13C11 13.5522 10.5522 14 10 14Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10Z",
  fill: "currentColor"
})));
export { SvgAddCircleOutline20 as ReactComponent };